import './App.css';
import Intro from "./components/intro";
import Train from "./components/train";
import { GlobalProvider } from './context/GlobalState';
import { HashRouter as Router, Routes, Route } from "react-router-dom";

function App() {

  return (
    <GlobalProvider>
    <Router>
      <Routes>
        <Route path="/train" element={<Train/>} />
        <Route path="/" element={<Intro/>} />
        <Route path="/intro" element={<Intro/>} />
      </Routes>
    </Router>
    </GlobalProvider>
  );
}

export default App;

